import { render, staticRenderFns } from "./fa-close.vue?vue&type=template&id=d4688092&"
import script from "./fa-close.vue?vue&type=script&lang=js&"
export * from "./fa-close.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports